import { DataTable, ValueAccessor } from '../../../models';
import { DateWindowFunction, DateWindowTypes } from '../core';
import { applyDateRangeWindow } from '../applyDateRangeWindow';
import { relativeToDateRangeWindow } from '../relativeToDateRangeWindow';
import { Duration } from '../../../models/Duration';

export interface LatestDataDateWindow {
  duration: Duration;
  type: DateWindowTypes.LATEST_DATA;
}

export const latestDataDateWindow = (duration: Duration, accessor: ValueAccessor<Date>): DateWindowFunction => {
  return (table: DataTable) => {
    const dateRange = relativeToDateRangeWindow(table, duration, accessor);
    return applyDateRangeWindow(table, dateRange, accessor);
  };
};

export const createRelativeWindow = (duration: Duration): LatestDataDateWindow => {
  return {
    type: DateWindowTypes.LATEST_DATA,
    duration,
  };
};
